//Funções para filtro dos markers
//Preferencialmente deve ser usado com o FilterMarkerFormjs

function MarkerControl(all_markers, options){
    this._map = map;
    this._all_markers = all_markers
    this._current_markers = all_markers

    this.filter = (filter_rules, from_current_markers = false)=>{
        
        let has_any_rule = false
        let filtered = undefined
        $.each(filter_rules, (field, values)=>{
            
            if(values.length > 0){
                has_any_rule = true
                let obj = this._all_markers
                
                if(filtered){
                    obj = filtered
                }
                try{
                    filtered = obj.filter(x=> values.includes(x.options[field] ? x.options[field].toString() : x.options[field]))
                } catch(e){
                    console.log("Erro ao tentar filtrar campo:" + field)
                }
            }
        })
        //caso nenhuma regra tenha sido passada, retorna todos os markers. No caso, seria em situações onde o filtro vem vazio
        filtered = (has_any_rule) ? (filtered || []) : this._all_markers
        
        this._current_markers = filtered
    }
    /**
     * Retorna um array com a option de todos os Markers. Ex: option 'prefix' retorna uma lista de todos os prefixos presentes na lista de markers.
     * return: [[id, value],[id, value]...]
     * @param {String} option nome do campo
     * @param {boolean} only_current apenas dos markers filtrados?
     * @returns {Array}
     */
    this.getOptionFromMarkers =(option, only_current, only_uniqs=true)=>{        
        let array = (only_current) ? this._current_markers.map(x=>[x.options[option+"_id"],x.options[option]]) : this._all_markers.map(x=>[x.options[option+"_id"], x.options[option]])
        array = (only_uniqs) ? [...new Map(array.map(x=>[x[0],x])).values()] : array
        return array
    }
    this.getCurrentMarkers = () =>{
        return this._current_markers
    }
    this.getAllMarkers = () =>{
        return this._all_markers
    }
}

export default MarkerControl